import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import CannedFile from '../../api/cannedFile';

const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    fetchingItem: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
  },
};

const getters = {
  getCannedFiles(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

const actions = {
  getCannedFile: async function getCannedFile({ commit }, { searchKey } = {}) {
    commit(types.default.SET_FILE_UI_FLAG, { fetchingList: true });
    try {
      const response = await CannedFile.get({ searchKey });
      commit(types.default.SET_FILE, response.data);
      commit(types.default.SET_FILE_UI_FLAG, { fetchingList: false });
    } catch (error) {
      commit(types.default.SET_FILE_UI_FLAG, { fetchingList: false });
    }
  },

  createCannedFile: async function createCannedFile({ commit }, cannedObj) {
    commit(types.default.SET_FILE_UI_FLAG, { creatingItem: true });
    try {
      const response = await CannedFile.create(cannedObj);
      commit(types.default.ADD_FILE, response.data);
      commit(types.default.SET_FILE_UI_FLAG, { creatingItem: false });
    } catch (error) {
      commit(types.default.SET_FILE_UI_FLAG, { creatingItem: false });
    }
  },

  updateCannedFile: async function updateCannedFile(
    { commit },
    { id, ...updateObj }
  ) {
    commit(types.default.SET_FILE_UI_FLAG, { updatingItem: true });
    try {
      const response = await CannedFile.update(id, updateObj);
      commit(types.default.EDIT_FILE, response.data);
      commit(types.default.SET_FILE_UI_FLAG, { updatingItem: false });
    } catch (error) {
      commit(types.default.SET_FILE_UI_FLAG, { updatingItem: false });
    }
  },

  deleteCannedFile: async function deleteCannedFile({ commit }, id) {
    commit(types.default.SET_FILE_UI_FLAG, { deletingItem: true });
    try {
      await CannedFile.delete(id);
      commit(types.default.DELETE_FILE, id);
      commit(types.default.SET_FILE_UI_FLAG, { deletingItem: true });
    } catch (error) {
      commit(types.default.SET_FILE_UI_FLAG, { deletingItem: true });
    }
  },
};

const mutations = {
  [types.default.SET_FILE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.default.SET_FILE]: MutationHelpers.set,
  [types.default.ADD_FILE]: MutationHelpers.create,
  [types.default.EDIT_FILE]: MutationHelpers.update,
  [types.default.DELETE_FILE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
